<template>
  <div class="wrapper">
    <div class="look-nav">
      <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
      <div class="look-nav-center">设备详情</div>
      <div class="handle-wrapper" @click="update"><div class="icon-font">&#xec11;</div>编辑</div>
    </div>
    <div class="equipment-detail">
      <div class="equipment-detail-list">
        <div class="input-contain">
          <div class="input-title">设备编号：</div>
          <div class="input-wrapper">
            <input v-model="tableItem.codeNum" placeholder=""/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">设备名称：</div>
          <div class="input-wrapper">
            <input v-model="tableItem.name" placeholder=""/>
          </div>
        </div>
        <div class="input-contain">
          <div class="input-title">位置：</div>
          <LoadingTreeStack :moduleType="moduleType"  :content="tableItem.gatherSite" :editCheckId="treeId" v-on:sendInfo = "showDropInfo"></LoadingTreeStack>
        </div>
        <div class="input-contain">
          <div class="input-title">管理人：</div>
          <DropDownInput type="1" :items="custodianValue" :content="tableItem.custodian" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
        </div>
      </div>
    </div>
    <img class="wrapper-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
import TreeSingle from '../../../components/TreeSingle.vue'
import LoadingTreeStack from '../../../components/LoadingTreeStack.vue'
import DropDownInput from '../../../components/DropDownInput.vue'
import {userList} from '../../../api/system'
import {updateEquipment, detailEquipment} from '../../../api/basic'
import {NonChineseInput, noEmpty} from '../../../tools/methods'
export default {
  name: 'EquipmentDetail',
  components: { LoadingTreeStack, TreeSingle, DropDownInput },
  data () {
    return {
      tableItem: {
        codeNum: '',
        custodian: '',
        custodian_id: '',
        gatherSite: '',
        id: '',
        name: '',
        siteId: '',
        siteRoute: '',
        siteType: '',
        status: '01'
      },
      siteId: '',
      siteType: '',
      moduleType: '00',
      treeId: '',
      custodianValue: []
    }
  },
  created () {
    detailEquipment({equipmentId: this.$route.query.equipmentId}).then(res => {
      console.log(res)
      this.tableItem = res.data
      this.handleSearchValue()
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    backPath: function () {
      this.$router.go(-1)
    },
    showDropInfo: function (data) {
      console.log(data)
      this.tableItem.gatherSite = data.gatherSite
      this.tableItem.siteId = data.id
      this.tableItem.siteType = data.siteType
    },
    showInfo: function (data) {
      this.tableItem.custodian = data.name
      this.tableItem.custodian_id = data.nodeId
      console.log(data)
    },
    sendValue: function (value) {
      console.log(value)
      this.handleSearchValue(value)
    },
    handleSearchValue: function (value) {
      let body = {
        keywork: value,
        page: 1,
        rows: 9999
      }
      userList(body).then(res => {
        console.log(res)
        this.custodianValue = res.data.rows
      }).catch(err => {
        console.log(err)
      })
    },
    update: function () {
      if (
        noEmpty(this.tableItem.name, '请输入设备名称', '') &&
        NonChineseInput(this.tableItem.codeNum, '请输入设备编号', '仓库代码不可输入中文', '') &&
        noEmpty(this.tableItem.gatherSite, '请选择位置', '') &&
        noEmpty(this.tableItem.custodian, '请选择管理人员', '')
      ) {
        updateEquipment(this.tableItem).then(res => {
          console.log(res)
          this.$message({
            message: '编辑成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style scoped>
@import "./Equipment.css";
</style>



// WEBPACK FOOTER //
// src/page/basic/equipment/EquipmentDetail.vue